import { render, staticRenderFns } from "./TotalView.vue?vue&type=template&id=fd76c10e"
import script from "./TotalView.ts?vue&type=script&lang=ts&external"
export * from "./TotalView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports